<template lang="pug">
el-dialog(width="560px", title="添加字典", :visible.sync="visible", @closed="reject", :close-on-click-modal="false")
  el-form(size="mini", ref="form", label-width="80px", :model="form", :rules="rules")
    el-form-item(label="字典名称", prop="dicName")
      el-input(v-model="form.dicName", maxlength="20", placeholder="请输入字典名称", show-word-limit)
    el-form-item(label="字典编号", prop="dicCode")
      el-input(v-model="form.dicCode", maxlength="20", show-word-limit, placeholder="请输入字典编号")
      .tips 提示: 只能输入字母、数字、下划线、减号、半角句号
    el-form-item(label="字典值", prop="raws")
      el-input(v-model="form.raws", type="textarea", :raws="8", placeholder="请输入字典值")
      .tips 提示: 每行一条记录。每行的第一列记录为值
      .tips 第二列为显示名称，中间用一个或多个空格隔开。
  template(#footer)
    el-button(@click="close()") 取消
    el-button(type="primary", @click="submit()") 提交
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import { getVfDictAdd } from "@/CommonDP/service/vf-component-service";
// import trim from "lodash/trim";
export default {
  mixins: [asyncMixin],
  data() {
    return {
      visible: false,
      form: { dicCode: "", dicName: "", raws: "" },
      rules: {
        dicName: { required: true, message: "请输入字典名称" },
        dicCode: { required: true, message: "提示: 只能输入字母、数字、下划线、减号、半角句号", pattern: /^(\w|\d|-|_|\.)+$/ },
        raws: { required: true, message: "请输入字典值" }
      }
    };
  },
  computed: {
    submitData() {
      const {
        form: { raws = "", ...form }
      } = this;
      const dicItemList = raws
        .split("\n")
        .map((str) => str.trim().replace(/\s+/, ","))
        .filter((str) => str);

      return { ...form, dicItemList };
    }
  },
  created() {
    this.open();
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    async submit() {
      await this.$refs.form.validate();
      const { submitData: form } = this;
      await getVfDictAdd(form);
      this.$emit("resolve", form.dicCode);
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: var(--info-color);
  font-size: 14px;
  line-height: 20px;
}
</style>
